// =============================================================================
// lienInterne.js : la CONDUITE d'un lien vers une autre page d'Aramis (R4 du
// bandeau de commande, décision de Pierre du 27/10/2026 : ce qui navigue est
// un lien, jamais un bouton). Une seule écriture, partagée par <Lien vue> des
// pages de travail (src/pageTravail.js, morceau paresseux) et par
// <LienSemaine> de l'accueil personnel (src/IndexSemaine.js, première page,
// qui ne charge pas les primitives des pages de travail) : les deux ne
// peuvent plus dériver (revue du lot 21, 01/11/2026).
//   • l'adresse : l'adresse profonde ?view=… (un vrai <a href>) ;
//   • le clic : un clic simple passe par la navigation de la coquille
//     (`onNav`), jamais par un rechargement ; le clic du milieu, Cmd, Ctrl,
//     Maj ou Alt laissent le navigateur ouvrir l'adresse ailleurs ; sans
//     `onNav`, l'adresse suffit.
// Petit et sans dépendance lourde : il voyage dans le bundle principal.
// =============================================================================
import { buildDeepLink } from "./deepLink";

/** L'adresse profonde d'une vue (et de ses paramètres). */
export const adresseVue = (vue, params = null) => buildDeepLink(vue, params);

// Un clic SIMPLE (bouton principal, sans Cmd, Ctrl, Maj ni Alt, pas déjà
// pris) : le seul que la page prend en charge ; les autres restent au
// navigateur (nouvel onglet, nouvelle fenêtre, téléchargement).
const clicSimple = (e) => !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

/** Le clic d'un lien interne : vrai quand la coquille l'a pris en charge. */
export function suivreLienVue(e, { vue, params = null, onNav }) {
  if (!onNav || !vue || !clicSimple(e)) return false;
  e.preventDefault();
  if (params) onNav(vue, params); else onNav(vue);
  return true;
}

/** Le clic d'un lien vers une fenêtre NOMMÉE (l'écran de salle, projeté) :
 *  un lien `noopener` ne retrouve pas une fenêtre par son nom (revue du lot 11
 *  de la grammaire : trois clics, trois écrans de salle). Le clic simple passe
 *  donc par window.open(href, cible, fenetre), qui la retrouve et garde ses
 *  dimensions ; les autres clics, et un window.open refusé (fenêtre
 *  bloquée), laissent le lien au navigateur. Vrai quand la page l'a ouvert. */
export function suivreFenetreNommee(e, { href, cible, fenetre = "" }) {
  if (!cible || !href || !clicSimple(e)) return false;
  let w = null;
  try { w = window.open(href, cible, fenetre || ""); } catch (x) { w = null; }
  if (!w) return false;
  e.preventDefault();
  try { w.focus(); } catch (x) { /* fenêtre déjà fermée */ }
  return true;
}
